import { render, staticRenderFns } from "./TSelectQuestion.vue?vue&type=template&id=48fd3adc&scoped=true"
import script from "./TSelectQuestion.vue?vue&type=script&lang=js"
export * from "./TSelectQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fd3adc",
  null
  
)

export default component.exports